var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "tap-tips" },
    [
      _c("span", [_vm._v(_vm._s(_vm.text))]),
      _vm._v(" "),
      _c(
        "tool-tip",
        {
          staticClass: "tip-message",
          attrs: { visiable: _vm.visiable, content: _vm.content }
        },
        [
          _c(
            "span",
            {
              ref: "tipIcon",
              staticClass: "tip-icon",
              style: _vm.color
                ? {
                    color: _vm.color,
                    borderColor: _vm.color
                  }
                : "",
              on: {
                mousemove: function($event) {
                  _vm.visiable = true
                },
                mouseout: function($event) {
                  _vm.visiable = false
                },
                click: function($event) {
                  _vm.visiable = true
                }
              }
            },
            [_vm._v("!")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }